import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../utils/api";

export default function CampaignSourceRedirect() {
  const { source } = useParams();
  const navigate   = useNavigate();

  useEffect(() => {
    const src = (source || "other").toLowerCase();
    // Log the visit, then redirect to campaign landing page
    axios.post(`${API}/campaign/track-visit`, { source: src }).catch(() => {});
    // QR sources automatically set src=qr headline
    const isQR = ["heavybags","bathroom","window","flyer","frontdesk","lobby"].includes(src);
    navigate(`/clicktowin?src=${src}${isQR ? "&qr=1" : ""}`, { replace: true });
  }, [source, navigate]);

  return null;
}
